"use client";

import { Card } from "@/components/ui/card";
import { Spotlight } from "@/components/ui/spotlight";
import { SplineScene } from "@/components/ui/splite";
import type { AppCopy, Direction } from "@/lib/i18n";

interface SplineSceneBasicProps {
  copy: AppCopy["spline"];
  direction: Direction;
}

export function SplineSceneBasic({ copy, direction }: SplineSceneBasicProps) {
  return (
    <Card className="relative h-[500px] w-full overflow-hidden border-slate-200/80 bg-white/90 text-slate-950 shadow-2xl shadow-slate-200/60 backdrop-blur transition-colors dark:border-white/10 dark:bg-black/[0.96] dark:text-white dark:shadow-black/40">
      <Spotlight
        className="-top-40 left-0 md:left-60 md:-top-20"
        fill="currentColor"
      />

      <div className="flex h-full flex-col md:flex-row">
        <div
          className="relative z-10 flex flex-1 flex-col justify-center p-8 text-start"
          dir={direction}
        >
          <h2 className="bg-gradient-to-b from-slate-950 to-slate-500 bg-clip-text text-4xl font-bold text-transparent md:text-5xl dark:from-neutral-50 dark:to-neutral-400">
            {copy.title}
          </h2>
          <p className="mt-4 max-w-lg text-slate-600 dark:text-neutral-300">
            {copy.description}
          </p>
        </div>

        <div className="relative min-h-[260px] flex-1">
          <SplineScene
            scene="https://prod.spline.design/kZDDjO5HuC9GJUM2/scene.splinecode"
            className="h-full w-full"
          />
        </div>
      </div>
    </Card>
  );
}
